import PropTypes from "prop-types";
import { useReportData } from "src/context/ReportContext";

export default function Report_ReportComponent_KuskiVehicleHeader({ kuski }) {
  const { settingsData } = useReportData();

  return (
    <div style={{ display: "flex", gap: 6 }} className="fixPrint">
      <div style={{ fontSize: settingsData.titleFontSize, transition: "0.3s all ease-in-out" }}>
        {kuski.personFirstName} {kuski.personLastName}
      </div>
      <div
        style={{
          display: "flex",
          fontSize: settingsData.titleFontSize - 2,
          transition: "0.3s all ease-in-out",
          gap: 6,
        }}>
        {kuski.vehicles.map((vehicle) => (
          <div key={vehicle.vehicleId}>
            {vehicle.vehicleNo} {vehicle.vehicleRegNo}
          </div>
        ))}
      </div>
    </div>
  );
}

Report_ReportComponent_KuskiVehicleHeader.propTypes = {
  kuski: PropTypes.object,
  mainComponent: PropTypes.oneOf(["kuski", "vehicle"]),
};
